import './footer.css';

export function Footer() {
  return (
    <footer className="site-footer">
      <ul className="site-footer__list">
        <li>(주) 스퀘어노트</li>
        <li>1522-4293</li>
        <li>contact@squareknot.co.kr</li>
      </ul>
    </footer>
  );
}
